import { EditMemberComponent } from '../edit-member/edit-member.component';
import { AddMemberComponent } from '../add-member/add-member.component';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  DocumentService, ServiceYearMemberService, SportTeamService, FestivalUserService 
} from 'src/core/services';
import { DocumentReference, ServiceYearMember, SportTeam } from '../../core/models';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { Gender } from 'src/core/enums';
import { PageClass } from 'src/core/classes/page';


@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.less', '../../core/styles/common.less']
})

export class MemberListComponent extends PageClass implements OnInit {

  membersGroupList: ServiceYearMember[];
  memberGroup: ServiceYearMember;
  sportTeamList: SportTeam[];
  //churchList: DocumentReference[] = [];

  filter: any = { filterAgeGroup: undefined, filterChurch: undefined };
  isLoading = true;

  @ViewChild('closeModal', null)  closeModal: ElementRef;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private docService: DocumentService,
    private serviceYearMemberService: ServiceYearMemberService,
    private router: Router,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,

    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController
  ) {
      super(
      ageGroupService, arrayService, authService, 
      churchService, databaseService, festivalUserService
    );
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      this.currentUser.ageGroupList.sort(this.arrayService.orderByDisplayName);

      this.filter.filterAgeGroup = this.getAgeGroupFilter();

      if (this.filter.filterAgeGroup == null)
        this.filter.filterAgeGroup = this.currentUser.ageGroupList[0];

      if (this.currentUser.isAdmin) {
        this.filter.filterChurch = localStorage.getItem('filteredChurch') ? 
        this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch')) : 
        this.churchList[0];

        this.getMemberGroupList();
      } else {
        this.churchList.push(this.currentUser.church);
        this.filter.filterChurch = this.currentUser.church;

        this.getMemberGroupList();
      }
    }
  }

  private getAgeGroupFilter = (): any => {
    return localStorage.getItem('filteredAgeGroup') ?
        this.currentUser.ageGroupList.find(c => c.reference.id == localStorage.getItem('filteredAgeGroup')) : 
        this.currentUser.ageGroupList[0];
  }


  public addMember = async (churchList: DocumentReference[], ageGroupList: DocumentReference[]) => {
    const modal = await this.modalController.create({
      component: AddMemberComponent,
      componentProps: {
        churchList,
        ageGroupList
      }
    });
    return await modal.present();
  }

  public editMember = async (memberGroup: ServiceYearMember) => {
    const modal = await this.modalController.create({
      component: EditMemberComponent,
      componentProps: {
        memberGroup
      }
    });
    return await modal.present();
  }

  public async setDeletionMember(memberGroupId: string) {
    // Get Member Group
    this.docService.getDocument(this.serviceYearMemberService.collection, memberGroupId).subscribe(memberGroup => {
      this.getTeamList(memberGroup);
    });
  }

  private async getTeamList(memberGroup: ServiceYearMember) {
    var teamMember = {
      displayName: `${this.memberGroup.member.displayName} - ${this.memberGroup.yearLevel.displayName} - ${this.memberGroup.gender.name}`, 
      reference: this.databaseService.doc(`${this.serviceYearMemberService.collection}/${this.memberGroup.id}`).ref
    };
    (await this.sportTeamService.getMemberTeams(teamMember)).subscribe (sportTeamList => {
      this.sportTeamList = sportTeamList;
      this.memberGroup = memberGroup;
    });
  }

  public deleteMemberGroup = (memberGroupId: string) => {
    this.docService.deleteDocument(this.serviceYearMemberService.collection, memberGroupId);
    this.closeModal.nativeElement.click();
  }

  public getMemberGroupList() {
    // Save Filters
    localStorage.setItem('filteredChurch', this.filter.filterChurch.reference.id);
    if (this.filter.filterAgeGroup)
      localStorage.setItem('filteredAgeGroup', this.filter.filterAgeGroup.reference.id);

    this.membersGroupList = [];
    this.serviceYearMemberService.getMembersGroups(this.filter.filterChurch, this.filter.filterAgeGroup).subscribe(membersGroupList => {
        this.membersGroupList = membersGroupList.sort(this.serviceYearMemberService.orderByMemberName);
        this.isLoading = false;
      });
  }
}
